import {SkeletonBlock,SkeletonImage,SkeletonPage,SkeletonTextLines} from './SkeletonPrimitives';

export function HomeAboutSkeleton() {
  return (
    <section className="section page-width skeleton-page home-about-skeleton" aria-busy="true">
      <div className="section-intro" aria-hidden="true">
        <SkeletonBlock className="skeleton-eyebrow" />
        <SkeletonBlock className="skeleton-heading skeleton-heading-wide" />
        <SkeletonTextLines />
      </div>
      <div className="split-feature">
        <SkeletonImage className="tall-image" />
        <div className="feature-copy">
          <SkeletonBlock className="skeleton-eyebrow" />
          <SkeletonTextLines />
          <SkeletonBlock className="skeleton-button" />
        </div>
      </div>
    </section>
  );
}

export function HomeServicesSkeleton() {
  return (
    <section className="section section-sand skeleton-page home-services-skeleton" aria-busy="true">
      <div className="page-width">
        <SkeletonBlock className="skeleton-eyebrow" />
        <SkeletonBlock className="skeleton-heading skeleton-heading-medium" />
        <SkeletonTextLines className="section-skeleton-copy" />
        <div className="service-grid">
          {[1, 2, 3].map((item) => (
            <article className="service-card" key={item} aria-hidden="true">
              <SkeletonBlock className="skeleton-eyebrow" />
              <SkeletonBlock className="skeleton-card-title" />
              <SkeletonTextLines />
            </article>
          ))}
        </div>
        <SkeletonBlock className="skeleton-button" />
      </div>
    </section>
  );
}

export function HomeProjectsSkeleton() {
  return (
    <section className="section page-width skeleton-page home-projects-skeleton" aria-busy="true">
      <SkeletonBlock className="skeleton-eyebrow" />
      <SkeletonBlock className="skeleton-heading skeleton-heading-medium" />
      <div className="project-grid project-grid-home">
        {[1, 2, 3].map((item) => <ProjectSkeleton key={item} />)}
      </div>
    </section>
  );
}

export function ProjectSkeleton() {
  return (
    <article className="project-card" aria-hidden="true">
      <SkeletonImage className="project-image-skeleton" />
      <div className="project-meta">
        <div>
          <SkeletonBlock className="skeleton-eyebrow" />
          <SkeletonBlock className="skeleton-card-title" />
        </div>
        <SkeletonTextLines />
      </div>
      <SkeletonBlock className="skeleton-button" />
    </article>
  );
}

export function InnerHeroSkeleton() {
  return (
    <section className="inner-hero page-width skeleton-page" aria-busy="true">
      <SkeletonBlock className="skeleton-eyebrow" />
      <SkeletonBlock className="skeleton-heading skeleton-heading-wide" />
      <SkeletonTextLines className="inner-skeleton-copy" />
    </section>
  );
}

export function GalleryHeroSkeleton() {
  return <InnerHeroSkeleton />;
}

export function ContactContentSkeleton() {
  return (
    <>
      <div className="contact-intro" aria-hidden="true">
        <SkeletonBlock className="skeleton-eyebrow" />
        <SkeletonBlock className="skeleton-heading-line skeleton-heading-line-wide" />
        <SkeletonTextLines className="contact-skeleton-copy" />
        <div className="contact-details">
          {[1, 2, 3].map((item) => (
            <div key={item}>
              <SkeletonBlock className="skeleton-eyebrow" />
              <SkeletonBlock className="skeleton-card-title" />
            </div>
          ))}
        </div>
      </div>
      <div className="contact-image" aria-hidden="true">
        <SkeletonImage className="contact-skeleton-image" />
        <SkeletonBlock className="skeleton-eyebrow contact-caption-skeleton" />
      </div>
    </>
  );
}

export function ServicesSkeleton() {
  return (
    <>
      <InnerHeroSkeleton />
      <section className="section page-width skeleton-page" aria-busy="true">
        <div className="service-list">
          {[1, 2, 3, 4].map((item) => (
            <article className="service-card service-card-detailed" key={item}>
              <SkeletonImage className="service-skeleton-image" />
              <div className="service-card-content">
                <SkeletonBlock className="skeleton-eyebrow" />
                <SkeletonBlock className="skeleton-card-title" />
                <SkeletonTextLines />
              </div>
            </article>
          ))}
        </div>
      </section>
      <section className="section section-sand skeleton-page" aria-busy="true">
        <div className="page-width">
          <SkeletonBlock className="skeleton-eyebrow" />
          <SkeletonBlock className="skeleton-heading skeleton-heading-medium" />
          <div className="process-grid">
            {[1, 2, 3, 4].map((item) => (
              <div className="process-step" key={item}>
                <SkeletonBlock className="skeleton-number" />
                <SkeletonBlock className="skeleton-card-title" />
                <SkeletonTextLines />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export function ProjectsSkeleton() {
  return (
    <>
      <InnerHeroSkeleton />
      <section className="section page-width skeleton-page" aria-busy="true">
        <div className="project-grid project-collection">
          {[1, 2, 3, 4].map((item) => <ProjectSkeleton key={item} />)}
        </div>
      </section>
    </>
  );
}

export function AboutSkeleton() {
  return (
    <>
      <InnerHeroSkeleton />
      <section className="section page-width skeleton-page editorial-two-col" aria-busy="true">
        <div>
          <SkeletonBlock className="skeleton-eyebrow" />
          <SkeletonBlock className="skeleton-heading skeleton-heading-medium" />
        </div>
        <SkeletonTextLines count={5} />
      </section>
      <section className="image-story page-width skeleton-page" aria-busy="true">
        <SkeletonImage className="inner-skeleton-image" />
      </section>
    </>
  );
}